<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
/>
<div class="modal-container custom-modal w-full mx-auto rounded">
  <div *ngIf="qrComponentDisplay$ | async as dp">
    <div *ngIf="dp === 'open'" id="profile">
      <div class="modal-container">
        <div
          class="modal-close cursor-pointer z-50"
          (click)="closeQRView()"
        >
          <svg
            class="fill-current text-slate-600"
            xmlns="http://www.w3.org/2000/svg"
            width="65"
            height="35"
            viewBox="0 0 18 18"
          >
            <path
              d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
              fill="white"
            ></path>
          </svg>
        </div>
      </div>
      
      <div>
        <div
          class="notification-modal fixed top-0 left-0 right-0 z-50 hidden w-full p-0 overflow-x-hidden overflow-y-auto md:inset-0 h-modal h-full animated fadeIn faster"
          style="display: flex"
        >
          <div class="modal-container custom-modal w-full mx-auto rounded">
            <div class="modal-content py-2 text-left px-2">
              <div class="flex justify-end pb-3"></div>

              <div>
                <section class="pt-16 bg-blueGray-50">
                  <div class="w-full lg:w-4/12 px-4 mx-auto">
                    <div
                      class="relative h-96 flex flex-col min-w-0 break-words user-block-bg w-full mb-6 shadow-xl rounded-2xl mt-16"
                    >
                    <qr-code
                    value="{{get_qr_content()}}"
                    size="300"
                    errorCorrectionLevel="H"
                  ></qr-code>
                    </div>
                    <div class="text-center mt-6">
                    <h3
                    class="text-xl font-medium leading-normal mb-2 uppercase"
                  >
                    {{ get_qr_controler_uuid() }}
                  </h3>
                  <span
                    class="w-32 divider bg-gray-500 block m-auto"
                  ></span>
                </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
